/**
 * Dev-only console logging — noisy emoji-prefixed debug logs should not spam
 * the console in production. console.error is unaffected; real errors should
 * always surface.
 */
export const devLog = (...args: unknown[]): void => {
  if (process.env.NODE_ENV === 'development') console.log(...args);
};

export const devWarn = (...args: unknown[]): void => {
  if (process.env.NODE_ENV === 'development') console.warn(...args);
};
